import { Point } from '../../services/zoom.service';

export class ZoomEvent {

    zoomLevel: number;
    mousePoint: Point;

    static createZoomEvent(zoomLevel: number, mousePoint?: Point): ZoomEvent {
        const zoomEvent = new ZoomEvent();
        zoomEvent.zoomLevel = zoomLevel;
        zoomEvent.mousePoint = mousePoint;

        return zoomEvent;
    }

}
